import { Container } from 'reactstrap';

const Welcome = () => (
    <Container
        className = 'sc-glass sc-rounded text-light p-5 mb-4 sticky-top'
        style={{ top: '4rem' }}>
        <h1>Welcome to Bitwerx SupportCo!</h1>
        <br />
        <h4 className="text-18">
            Select a practice from the practice list to begin
        </h4>
    </Container>
);

export default Welcome;
